<template>
  <div class="w-full h-full flex-1 flex flex-col items-center text-white px-[20px]">
    <Image class="size-[58px] mt-[80px]" :src="success" alt="" />
    <div class="text-[20px] mt-[30px] mb-[10px]">{{ $t('SaquePw.ConfiguredSuccessfully') }}</div>
    <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/50">
      {{ $t('SaquePw.PwoSsettingSuccessfulTips') }}
    </div>
    <v-button @click="navigateHome" class="primaryBtn mt-[30px]">
      {{ $t('SaquePw.ReturnToHome') }}
    </v-button>
    <v-button @click="$router.push('/chooseSaque')" class="primaryBtn_transparent mt-[15px]">
      {{ $t('SaquePw.ContinueWithTheWithdrawal') }}
    </v-button>
  </div>
</template>

<script setup lang="ts">
import success from "./../images/success.png";
const router = useRouter();
const navigateHome = () => {
  router.push("/");
};
</script>

<style lang="scss" scoped></style>
